import request from '../utils/request'

export function getInfo(data) {
    return request({
        url: 'api/lclyuser/getuserinfo?code=' + data,
        method: 'get'
    })
}

export function getJsapiToken() {
    return request({
        url: 'api/lclyuser/jsapi',
        method: 'get'
    })
}

export default { getInfo, getJsapiToken }


// WEBPACK FOOTER //
// ./src/api/user.js